<script setup lang="ts">
import { sendUserVerifyCodeApi } from '@/api/mailer'
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import { socketEmitAsync } from '@/utils/web-socket'
import { Lock, Message } from '@element-plus/icons-vue'
import type { FormInstance } from 'element-plus'
import { reactive, ref } from 'vue'

const commonStore = useCommonStore()
const userStore = useUserStore()

const emits = defineEmits(['success'])

const formRef = ref<FormInstance>()
const form = reactive({
  email: '',
  code: '',
})
const formRules = reactive<{ email: any[]; code?: any[] }>({
  email: [
    { required: true, message: '请输入' },
    {
      pattern:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: '请输入正确的邮箱',
      trigger: 'blur',
    },
  ],
})

const isSendCode = ref(false)
async function handleSendCode() {
  formRef.value?.validate(async (valid) => {
    if (!valid) return
    await sendUserVerifyCodeApi({ email: form.email })
    isSendCode.value = true
    formRules.code = [
      { required: true, message: '请输入' },
      { min: 6, max: 6, message: '验证码为6位数字', trigger: 'blur' },
    ]
  })
}
async function handleSubmit() {
  formRef.value?.validate(async (valid) => {
    if (!valid) return
    const email = await socketEmitAsync<string>({ type: 'bindEamil', data: { code: form.code } })
    userStore.email = email
    userStore.diamond += 300
    emits('success')
  })
}
</script>

<template>
  <div class="bind-email">
    <el-form ref="formRef" :model="form" :rules="formRules" v-loading="commonStore.loading">
      <el-form-item prop="email">
        <el-input v-model="form.email" :prefix-icon="Message" placeholder="请输入邮箱">
          <template #append>
            <el-button type="primary" @click="handleSendCode" :disabled="isSendCode">{{ !isSendCode ? '发送验证码' : '已发送' }}</el-button>
          </template>
        </el-input>
        <p style="font-size: 12px; color: red" v-show="!isSendCode">* 发送失败时，请稍等一段时间再进行绑定</p>
        <p style="font-size: 12px; color: red" v-show="isSendCode">* 若未收到请看邮件垃圾箱</p>
        <p style="font-size: 12px; color: red">* 邮件绑定后无法修改</p>
      </el-form-item>
      <el-form-item prop="code" v-show="isSendCode">
        <el-input v-model="form.code" :prefix-icon="Lock" placeholder="请输入验证码" @keydown.enter="handleSubmit"> </el-input>
      </el-form-item>
      <el-form-item>
        <div style="width: 100%; text-align: center">
          <el-button type="primary" plain style="width: 80%; margin-bottom: 10px" @click="handleSubmit">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped></style>
